
;
                (function(){
                    const Func = (function() {
                        var e=this.$el;if(e&&this.isLive){var t=e.querySelectorAll(".element-social-link");t.length&&t.forEach(function(n){var r=n.getAttribute("href")||"#",i=r.replace("{current-link}",location.href);n.setAttribute("href",i)})}
                    
                    });
                    const settings = {};
                    const ID = 'ecom-dcn3b701mmf';
                    document.querySelectorAll('.ecom-dcn3b701mmf').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.layout==="slider"){let t=this.$el;if(!t)return;let i=t.querySelector(".ecom-shopify__blog-container"),o=i&&i.dataset.optionSwiper;o=JSON.parse(o),o.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:"bullets",clickable:!0},o.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(i,o)}
                    
                    });
                    const settings = {"layout":"grid"};
                    const ID = 'ecom-nvv3q530rw';
                    document.querySelectorAll('.ecom-nvv3q530rw').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            
                (function(){
                    const Func = (function() {
                        if(this.settings.layout==="slider"){let t=this.$el;if(!t)return;let i=t.querySelector(".ecom-shopify__blog-container"),o=i&&i.dataset.optionSwiper;o=JSON.parse(o),o.pagination={el:t.querySelector(".ecom-swiper-pagination"),type:"bullets",clickable:!0},o.navigation={nextEl:t.querySelector(".ecom-swiper-button-next"),prevEl:t.querySelector(".ecom-swiper-button-prev")},new window.EComSwiper(i,o)}
                    
                    });
                    const settings = {"layout":"grid"};
                    const ID = 'ecom-5lb5e9tpwv8';
                    document.querySelectorAll('.ecom-5lb5e9tpwv8').forEach(function(el){
                        Func.call({$el: el, settings, id:ID,isLive: true});
                    });
                })();
            